import { Checkbox } from '@delmonicos/shared-design-system-react/src/components/checkbox/checkbox';
import { SetChargePointsLocationModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/inputs/set-charge-points-location.model';
import { GatewayChargePointModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point.model';
import { useSetChargePointsLocationFormValidation } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/inputs/charge-point/set-charge-points-location.form-validation';
import { CellContext } from '@tanstack/react-table';
import { Controller, useFormContext } from 'react-hook-form';

export interface LocationChargePointListUpdateFormStep1SelectCellProps
  extends CellContext<GatewayChargePointModel, unknown> {}

export const LocationChargePointListUpdateFormStep1SelectCell = (
  props: LocationChargePointListUpdateFormStep1SelectCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { row } = props;

  const { control } =
    useFormContext<
      Pick<SetChargePointsLocationModel, 'chargePointIds' | 'locationId'>
    >();

  const { chargePointIds } = useSetChargePointsLocationFormValidation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Controller
      name="chargePointIds"
      control={control}
      rules={chargePointIds}
      render={({ field }) => {
        const checked = field.value.includes(row.original.id);

        return (
          <Checkbox
            id={row.id}
            label=""
            checked={checked}
            {...field}
            onChange={() => {
              if (checked) {
                field.onChange(
                  field.value.filter((id) => id !== row.original.id),
                );
              } else {
                field.onChange([...field.value, row.original.id]);
              }
            }}
          />
        );
      }}
    />
  );
};
